<div data-cy="date-range-picker__page" class="inputDate" *ngIf="layout == 'chart'">
  <mat-form-field appearance="outline" class="custom-date-range-set">
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input data-cy="date-range-picker__start-input" matStartDate formControlName="start" placeholder="Start date">
      <input data-cy="date-range-picker__end-input" matEndDate formControlName="end" placeholder="End date" [max]="maxDate">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker" [class]="uniqueId"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</div>
